import { expVal } from '@atlassian/jira-feature-experiments';

/**
 *
 * @returns {boolean} Whether the experiment is enabled or not.
 * @description
 *  This function evaluates the A/A experiment for jira_powerful_inline_create_in_list_view experiment and logs the exposure.
 *  It will not change the behavior of the application.
 */
export const fireExposureForPowerfulInlineCreateAATest = () => {
	expVal('jira_powerful_inline_create_experiments_aa', 'isEnabled', false);
};
